import { useMutation } from '@tanstack/react-query';
import { Col, Row } from 'antd';
import { useCallback, useEffect, useRef, useState } from 'react';

import { SaleDealApi } from 'apis/SaleDealApis';
import { Loader } from 'assets/svg';
import { Button, ButtonFilter } from 'components';
import { useTitle } from 'contexts/TitleProvider';
import useQueryParam from 'hooks/useQueryPrams';
import { IGetListSaleDealParams, ISaleDeal } from 'interfaces/SaleDeal';
import { DEFAULT_PAGE_SIZE } from 'utils/constants/constant';
import { icons } from 'utils/constants/icons';
import FilterSaleDeal from './FilterSaleDeal';
import TableSaleDeal from './TableSaleDeal';

export interface ISaleDealData {
  items: ISaleDeal[];
  pageInfo?: any;
}

const initSaleDealData: ISaleDealData = {
  items: [] as ISaleDeal[],
};

const { PlusOutlined } = icons;

const SaleDeal = () => {
  const tableRef = useRef<any>(null);
  const { setTitle, setBreadcrumb } = useTitle();

  const [saleDealData, setSaleDealData] =
    useState<ISaleDealData>(initSaleDealData);

  const [filterData, setFilterData] = useState({});

  const [selectedIndex, setSelectedIndex] = useState(-1);
  const [isOpenFilter, setIsOpenFilter] = useState(false);

  const queryParam = useQueryParam(),
    page = parseInt(queryParam.get('page') + '') || 1,
    page_size = parseInt(queryParam.get('page_size') + '') || DEFAULT_PAGE_SIZE;

  const { isPending: getListSaleDealLoading, mutate: getListSaleDeal } =
    useMutation({
      mutationFn: (params: IGetListSaleDealParams) =>
        SaleDealApi.getListSaleDeal(params),
      onSuccess: (res) => {
        const data = res?.data?.getVoucher;

        if (!data) {
          setSaleDealData(initSaleDealData);
          return;
        }

        setSaleDealData({
          items: data.items,
          pageInfo: data.pageInfo,
        });
      },
      onError: (error) => {
        console.log(error);
      },
    });

  const refetchSaleDeal = useCallback(() => {
    const params = {
      page: page,
      pageSize: page_size,
      ...filterData,
    };

    getListSaleDeal(params);
  }, [page, page_size, filterData]);

  useEffect(() => {
    setTitle('Chương trình KM');
    setBreadcrumb([{ title: 'Hệ thống' }, { title: 'Chương trình KM' }]);
  }, [setTitle, setBreadcrumb, refetchSaleDeal]);

  useEffect(() => {
    refetchSaleDeal();
  }, [refetchSaleDeal]);

  const handleAddRow = () => {
    if (tableRef && tableRef.current) {
      setIsOpenFilter(false);
      tableRef.current.handleAddRow();
    }
  };

  const handleSaveRow = useCallback((values: ISaleDeal) => {
    console.log(values);
  }, []);

  const handleOkFilter = useCallback((values: any) => {
    setFilterData(values);
  }, []);

  const handleCancelFilter = useCallback(() => {
    setFilterData({});
  }, []);

  return (
    <>
      <Row gutter={[8, 16]} align={'middle'} justify={'end'}>
        <Col>
          <ButtonFilter
            isOpen={isOpenFilter}
            disabled={selectedIndex !== -1}
            setIsOpen={setIsOpenFilter}
          />
        </Col>
        {/* <Col>
          <Button
            fill
            title="Tạo"
            disabled={selectedIndex !== -1}
            iconBefore={<PlusOutlined />}
            handleOnclick={handleAddRow}
          />
        </Col> */}
        <Col>
          <Button
            fill
            title="Cập nhật"
            iconBefore={<Loader />}
            disabled={selectedIndex !== -1}
          />
        </Col>
      </Row>
      <FilterSaleDeal
        isOpen={isOpenFilter}
        onFinish={handleOkFilter}
        onCancel={handleCancelFilter}
      />
      <TableSaleDeal
        ref={tableRef}
        data={saleDealData}
        selectedIndex={selectedIndex}
        loading={getListSaleDealLoading}
        onSave={handleSaveRow}
        setData={setSaleDealData}
        setSelectedIndex={setSelectedIndex}
      />
    </>
  );
};

export default SaleDeal;
